<template>
  <div id="perfil_div">
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>
            <v-icon large left>
              mdi-at
            </v-icon>
            <span class="title font-weight-light">{{$store.state.user.email}}</span>
          </v-card-title>

          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>¿Firma activa?</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $store.state.user.info_firma.mensaje }} 
                    <v-icon small> {{ $store.state.user.info_firma.firma_valida == true ? 'mdi-check-decagram' : 'mdi-close-circle' }} </v-icon>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Fecha vencimiento de la firma</v-list-item-title>
                  <v-list-item-subtitle>{{ $store.state.user.info_firma.fecha_vencimiento }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-btn 
              hidden
              small 
              class="ma-2" 
              color="info"
              :to="{name: 'solicitud-firma'}"
              >
              <v-icon left>mdi-form-select</v-icon>
              Solicitar firma
            </v-btn>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>
          <v-card-subtitle v-if="mostrar_roles">Permisos</v-card-subtitle>
          <v-card-text v-if="mostrar_roles">
            <template v-for="(roles_, index) in $store.state.user.roles">
              <v-chip small label class="mr-2 mb-2">{{ roles_ }}</v-chip>
            </template>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8">

        <v-card>
          <v-card-title>
            Firmas
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogForm = true">Asociar certificado</v-btn>
          </v-card-title>
          <v-data-table 
            :headers="headers"
            :items="array_firmas"
            :items-per-page="10"
            class="elevation-1"
            :footer-props="{
              showFirstLastPage: true,
                'items-per-page-text':'Registros por página',
                'items-per-page-all-text': 'Todos',
            }"
            
            
            >
            <template v-slot:item.action="{ item }">
              <!--<v-btn fab x-small @click="editar(item)" class="mr-2">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>-->
              <v-btn 
                fab 
                x-small
                :disabled="item.correo == $store.state.user.email"
                @click="dialog=true; current_item=item;">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.estado="{ item }">
                <v-chip v-if="item.estado == 'INACTIVO'" x-small color="red" text-color="white">Inactivo</v-chip>
                <v-chip v-else x-small color="success" text-color="white">Activo</v-chip>
            </template>
          </v-data-table>

          <v-dialog v-model="dialog" v-if="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline"></v-card-title>
              <v-card-text>Desea eliminar el item {{current_item.correo }}?</v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
                  <v-btn color="green darken-1" text @click="dialog = false; eliminarFirma();">Si</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogForm" persistent max-width="600px">
            <v-card>
              <v-card-title class="headline">
                <span v-if="es_nueva">Agregar certificado</span>  
                <span v-if="!es_nueva">Editar certificado</span>  
              </v-card-title>
              <v-card-text>

                <v-form 
                  ref="form" 
                  v-model="valid" 
                  lazy-validation>
                  <v-text-field 
                    v-model="correo" 
                    label="Correo" 
                    :rules="emailRules" 
                    prepend-icon="email" 
                    type="email">
                  </v-text-field>
                  <v-text-field 
                    v-model="password" 
                    label="Contraseña" 
                    prepend-icon="lock" 
                    color="blue"
                    :type="show1 ? 'text' : 'password'"
                    :rules="[rules.required]" 
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1">
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="blue darken-1" text @click="dialogForm = false; $refs.form.reset()"> Cerrar </v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!valid" v-if="es_nueva" color="primary" @click="guardarFirma"> Grabar </v-btn>
                <v-btn :disabled="!valid" v-if="!es_nueva" color="primary" @click=""> Actualizar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>

          <p>&nbsp;</p>
          <FormCambioClave></FormCambioClave>  
      </v-col>

    </v-row>

    <v-row justify="center">
    <v-dialog v-model="show_modal" persistent max-width="500px">
      <v-card>
        <v-card-title>
            <v-icon large left>
              mdi-email
            </v-icon>
            <span class="title font-weight-light">Se ha notificado su solicitud de firma</span>
        </v-card-title>

        <v-card-text>
          <span class="font-weight-light">Servicio al cliente se pondrá en contacto con su persona para dar seguimiento a su solicitud.</span>
        </v-card-text> 
                

          <v-card-actions>
            <v-btn color="blue" text @click="show_modal = !show_modal">Cerrar</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
  </div>
</template>

<script>
import axios from "axios";
import FormCambioClave from '@/components/FormCambioClave.vue'; 

export default {
  components: { 
    FormCambioClave
  },
  data: function() {
    return {
      show_modal :false,
      headers: [
        { text: 'Correo Electrónico', value: 'correo', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],      
      dialog: false,
      array_firmas: [{
        "id": Math.random(),
        "clienteId": Math.random(),
        "correo": this.$store.state.user.email
      }],
      planes :null,
      current_item: null,
      valid: true,
      es_nueva: true,
      dialogForm: false,
      password: null,
      correo: null,
      show1: false,
      mostrar_roles: false,
      emailRules: [
        v => !!v || 'Correo requerido',
        v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
      ],
      rules: {
        required: value => !!value || 'Requerido',
        min: v => v.length >= 8 || 'Minimo 8 caracteres',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },

    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {
    
  },
  mounted() {
    this.getCertificados();
    this.verificar_roles();
  },
  methods: {
    async verificar_roles(){

        if(this.planes == null){
          await this.validar();
        }
        let filtrado = this.planes.filter(e => (
          e.planId == 1 ||
          e.planId == 5 ||
          e.planId == 6 ||
          e.planId == 7 ||
          e.planId == 8 ||
          e.planId == 9 ||
          e.planId == 11 ||
          e.planId == 12 ||
          e.planId == 17 ||
          e.planId == 18 ||
          e.planId == 19 ||
          e.planId == 20 ||
          e.planId == 21 ||
          e.planId == 41 ||
          e.planId == 22 ));
        let visible = false; 

        visible = !(filtrado.length == 0);
        
        this.mostrar_roles = visible;
        return true;
      },
      async validar(){
          try{
            const resp = await axios.post('Agrupador/listar_planes_propios', { "Id": parseInt(this.$route.params.id) }, { 'headers': this.$store.state.user.headers });
            this.planes = resp.data.filter(e => e.estado == 'ACTIVO');
            return this.planes;
          }catch (err){
            console.log("ERROR EN EL CALLBACK" + err);
          }
      },
    getCertificados() {
      let getRols = axios.get('Usuario/listar_certificados_asociados', { 'headers': this.$store.state.user.headers });
      return getRols.then((callback) =>
      {
        callback.data.forEach((item,index) => {
          this.array_firmas.push(item);
        })
      }).catch((error) => {
        console.log("ERROR EN EL CALLBACK" + error);
      });
    },
    guardarFirma() {
      if (this.$refs.form.validate()) {
        let getuser = axios.post('Usuario/asociar_certificado', { 'correo': this.correo, 'clave': this.password},{ 'headers': this.$store.state.user.headers })
        return getuser.then((callback) => 
        {
          if(callback.status == 200){
            this.array_firmas.push({ "id": Math.random(), "clienteId": Math.random(), "correo": this.correo });
            this.dialogForm = false;
            this.$refs.form.reset();
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Cuenta asociada con éxito' });
          }
        }).catch((error1) => {
          console.log(error1);
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error1.response.data });
        });
      }
    },
    eliminarFirma() {
      let getRols = axios.post('Usuario/eliminar_certificado_asociado', {  "correo":this.current_item.correo }, { 'headers': this.$store.state.user.headers });
      return getRols.then((callback) =>
      {
        if(callback.status == 200) {
          this.array_firmas.splice(this.array_firmas.findIndex(v => v.correo == this.current_item.correo), 1);
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
        }
      }).catch((error) => {
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: error.response.data });
      });
    },
    solicitarFirma() {
      let solicitrFirma = axios.post('SolicitudFirma/enviar_solictud', {  "correo":this.$store.state.user.email }, { 'headers': this.$store.state.user.headers });
      return solicitrFirma.then((callback) =>
      {
        console.log(callback);
        if(callback.status == 200) {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Se ha realizado la solicitud de firma por correo.' });
            this.show_modal = true;
            console.log("se envio la firma")
        }
      }).catch((error) => {
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: "No se pudo realizar la petición de firma." });
      });
    }
  },
};
</script>